import gql from "graphql-tag";

export const updateUserGQL = gql`
  mutation updateUser($input: UserUpdateInput!) {
    updateUser(input: $input) {
      message
    }
  }
`;

export const updateUserMetadataGQL = gql`
  mutation UpdateUserMetadata($input: UserMetadataInput!) {
    updateUserMetadata(input: $input) {
      message
    }
  }
`;

export const claimFreeCoinsGQL = gql`
  mutation ClaimFreeCoinsGQL {
    claimFreeCoins {
      message
    }
  }
`;

export const generateUploadURLGQL = gql`
  mutation GenerateUploadURL($input: SignedURLInput!) {
    generateUploadURL(input: $input) {
      url
    }
  }
`;

export const claimLoginRewardGQL = gql`
  mutation Mutation($day: Int!) {
    claimLoginReward(day: $day) {
      message
    }
  }
`;

export const startContentViewGQL = gql`
  mutation Mutation($input: ViewContentInput!) {
    startContentView(input: $input) {
      contentId
    }
  }
`;

export const completeContentViewGQL = gql`
  mutation Mutation($input: CompleteContentInput!) {
    completeContentView(input: $input) {
      message
    }
  }
`;

export const redeemVoucherGQL = gql`
  mutation RedeemVoucher($input: RedeemVoucherInput!) {
    redeemVoucher(input: $input) {
      message
    }
  }
`;

export const initiatePurchaseGQL = gql`
  mutation InitiatePurchase($input: InitiatePurchaseInput!) {
    initiatePurchase(input: $input) {
      orderId
      gateway
      status
      amount
      paymentUrls {
        web
        iframe
        mobile
      }
      sdkPayload {
        ... on JuspaySdkPayload {
          requestId
          service
          payload
        }
      }
    }
  }
`;

export const verifyPurchaseGQL = gql`
  mutation VerifyPurchase($input: VerifyPurchaseInput!) {
    verifyPurchase(input: $input) {
      orderId
      gateway
      status
      mandateStatus
    }
  }
`;

export const cancelSubscriptionGQL = gql`
  mutation CancelSubscription($input: CancelSubscriptionInput!) {
    cancelSubscription(input: $input) {
      message
    }
  }
`;

export const unlinkEonAccountGQL = gql`
  mutation UnlinkEonAccount($provider: EonAccountProvider!) {
    unlinkEonAccount(provider: $provider) {
      message
    }
  }
`;
